import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import '../css/Warehouse.css';
import ListDeposit from './deposit/ListDeposit';

class Deposit extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path={`${this.props.match.url}`}
            component={() => <ListDeposit match_parent={this.props.match} />}
          />
        </Switch>
      </div>
    );
  }
}

export default Deposit;
